import SocieteDetailController from './societe.detail.controller';

export default {
    template: require('./societe.detail.html'),
    controller: SocieteDetailController
};
